// extracted by mini-css-extract-plugin
export default {"TableTitle":"Billing_TableTitle__9ub0v"};